import { IEditPackageTypePayload, IGetPackageTypeList, IPackageTypeCreate, IPackageTypeDetails, IPackageTypeListSearch } from "../../../types/master/packageTypeInterface";
import { PackageTypeActionTypes, PackageTypeActions } from "../../actionTypes/master/packageTypeActionTypes";

export const createPackageType = (payload: IPackageTypeCreate): PackageTypeActionTypes => ({
  type: PackageTypeActions.CREATE_PARCEL,
  payload,
});

export const getPackageTypeList = (payload: IPackageTypeListSearch): PackageTypeActionTypes => ({
  type: PackageTypeActions.GET_PARCEL_LIST,
  payload,
});

export const setPackageTypeList = (payload: Array<IGetPackageTypeList>) : PackageTypeActionTypes => ({
  type: PackageTypeActions.SET_PARCEL_LIST,
  payload
})

export const setPackageTypeListPageCount = (payload:number): PackageTypeActionTypes => ({
  type: PackageTypeActions.SET_PARCEL_LIST_PAGE_COUNT,
  payload
})

export const getPackageTypeDataById = (id: number): PackageTypeActionTypes => ({
  type: PackageTypeActions.GET_PARCEL_DATA_BY_ID,
  payload: id
})

export const setPackageTypeDataById = (payload: IPackageTypeDetails) => ({
  type: PackageTypeActions.SET_PARCEL_DATA_BY_ID,
  payload
})

export const editPackageType = (payload: IEditPackageTypePayload) => ({
  type: PackageTypeActions.EDIT_PARCEL_DATA_BY_ID,
  payload,
});
